import { CurrencyOne, CurrencyRate } from "@/components/l10n/Currency.tsx";
import { siteCurrencyAtom } from "@/config.ts";
import type { CurrencyInfo } from "@/modules/currency/currencyInfo.ts";
import { useAtomValue } from "jotai/react";

/** 1 USD = 123 JPY */
export function ExchangeRateExample({ currency }: { currency: CurrencyInfo }) {
    const siteCurrency = useAtomValue(siteCurrencyAtom);

    return (
        <>
            <CurrencyOne currency={siteCurrency} /> = <CurrencyRate value={currency.rate} currency={currency.code} />
        </>
    );
}
